export default {
  "content": "<path d=\"M21 5.5a1 1 0 011 1v15a1 1 0 01-1 1h-2v-2h1v-13H8v13h1v2H7a1 1 0 01-1-1v-15a1 1 0 011-1h14z\" fill=\"#7B61FF\"/><path d=\"M13 22.5h-2v-2h2v2zM17 22.5h-2v-2h2v2zM17 3.5H4v14H2v-15a1 1 0 011-1h14v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};